import { z } from "zod";
export const difficultyLevels = ["easy", "normal", "difficult", "very_difficult"];
export const packingServices = ["self", "partial", "full"];
export const roomTypes = [
    "bedroom_single",
    "bedroom_double",
    "living_room",
    "dining_room",
    "kitchen",
    "bathroom",
    "office",
    "garage",
    "garden",
    "shed",
    "storage",
    "loft",
    "basement",
];
export const roomItemSchema = z.object({
    type: z.enum(roomTypes),
    quantity: z.number().int().min(0).max(20),
});
export const moveSchema = z.object({
    rooms: z.array(roomItemSchema).min(1, "Add at least one room"),
    difficultyPickup: z.enum(difficultyLevels).default("normal"),
    difficultyDelivery: z.enum(difficultyLevels).default("normal"),
    hasElevatorPickup: z.boolean().default(false),
    hasElevatorDelivery: z.boolean().default(false),
    parkingAvailablePickup: z.boolean().default(true),
    parkingAvailableDelivery: z.boolean().default(true),
    pickupFloors: z.number().int().min(0).max(50).default(0),
    deliveryFloors: z.number().int().min(0).max(50).default(0),
    disassemblyItems: z.number().int().min(0).default(0),
    reassemblyItems: z.number().int().min(0).default(0),
    hasPiano: z.boolean().default(false),
    heavyAppliances: z.number().int().min(0).default(0),
    hasFragileItems: z.boolean().default(false),
    packingService: z.enum(packingServices).default("self"),
    helpers: z.number().int().min(0).max(5).default(0),
    requiresStorage: z.boolean().default(false),
    notes: z.string().max(500).optional(),
});
//# sourceMappingURL=schema.js.map